module.exports = __webpack_public_path__ + "static/media/hero-payee-faq.03659f23.png";